import { Component, Input, OnInit } from '@angular/core';
import {MaterialModule} from '../../material/material.module';

@Component({
  selector: 'app-header-dialog',
  templateUrl: './header-dialog.component.html',
  styleUrls: ['./header-dialog.component.scss']
})
export class HeaderDialogComponent implements OnInit {
  
  @Input() iconName!: string;

  constructor() { }

  ngOnInit(): void {
    // Você pode adicionar uma verificação manual se quiser ser mais rigoroso em runtime:
    /*
    if (!this.iconName) {
      console.error('The input "iconName" is required for app-icon-label.');
    }
    */
  }
}
